export default "__VITE_ASSET__BAu7f9ci__"